// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON;

if (!SUPABASE_URL || !SUPABASE_ANON) {
  console.warn('⚠️ Supabase env vars missing. Auth will not work.');
}

export const supabase = createClient(
  SUPABASE_URL  || 'https://bozsqzvnedszbxonvjsf.supabase.co',
  SUPABASE_ANON || 'sb_publishable_FxB5ipGp_7QBglQHEAioww_Yc9vLwU_',
  {
    auth: {
      redirectTo: 'https://thetradeclass.com/dashboard',
    }
  }
);